module.exports = __webpack_public_path__ + "media/notice7.5a7cd8b3.mp3";